// [ABOUT]
// The purpose of this is to have registration specific status codes
// and common status codes. In the case of common status codes they 
// should be for commonly applied status's. Therefore, the CommonStatus
// is not only referenced here, but is also referenced in each portal
// status component.
import '../../less/registration.less';
import { Modal } from 'antd';
import CandidateStatus from './CandidateStatus';
import CandidateRecoveryStatus from './CandidateRecoveryStatus';
import ProviderStatus from './ProviderStatus';
import DodStatus from './DodStatus';
import FsdoStatus from './FsdoStatus';
import RecoveryStatus from './RecoveryStatus';
import RegistrationHeader from './RegistrationHeader';
import RecoveryFooter from './RecoveryFooter';

export default class AccountRecoveryStatus extends React.Component {
    state = { modalProps: {
        closable: false,
        footer: false,
        centered: true,
        destroyOnClose: true
    }}

    constructor(props) { super(props); }
    handleError = status => this.props.failureCallback(status);

    render() {
        const 
        { modalProps } = this.state,
        {recoveryCode, type, visible, status, noFailureModal, pendingCallback, successCallback, failureCallback, ...custom } = this.props,
        data = { modalProps, type, status, pendingCallback, successCallback, failureCallback, custom, recoveryCode };
        console.log(recoveryCode);
        return status !== 'pending' && status !== 'success' && noFailureModal ? this.handleError(status) : (
            <div>
                <Modal
                    visible={visible}
                    bodyStyle={{ padding: '20px' }}
                    {...modalProps}
                >
                    <div className={
                        status === 'pending' ? 'ss-cmpts-reg-status-color-indicator-pending'
                        : status === 'success' ? 'ss-cmpts-reg-status-color-indicator-success'
                        : ''
                    } />
                    <RegistrationHeader {...data} />{
                        type === 'candidate' ? <CandidateStatus {...data} />
                        : type === 'recovery' ? <CandidateRecoveryStatus {...data} />
                        : type === 'provider' ? <ProviderStatus {...data} />
                        : type === 'dod' ? <DodStatus {...data} />
                        : type === 'fsdo' ? <FsdoStatus {...data} />
                        : type === 'recovery' ? <RecoveryStatus {...data}  />
                        : null
                    }<RecoveryFooter {...data} />
                </Modal>
            </div>
        )
    }
}